import type { BackupEnvelope } from '../storage/backup.js';

export interface SyncAdapterMeta {
  id: string;
  name: string;
  description: string;
  requiresNetwork: boolean;
}

export interface SyncRemoteFile {
  id: string;
  name: string;
  modifiedAt: string;
  byteLength: number;
}

export interface SyncAdapter {
  meta: SyncAdapterMeta;
  isAvailable(): Promise<boolean>;
  isConnected(): Promise<boolean>;
  connect(): Promise<void>;
  disconnect(): Promise<void>;
  list(): Promise<SyncRemoteFile[]>;
  upload(env: BackupEnvelope): Promise<SyncRemoteFile>;
  download(id: string): Promise<BackupEnvelope>;
  remove(id: string): Promise<void>;
}

const adapters = new Map<string, SyncAdapter>();

export function registerAdapter(adapter: SyncAdapter): void {
  adapters.set(adapter.meta.id, adapter);
}

export function listAdapters(): SyncAdapter[] {
  return [...adapters.values()];
}

export function getAdapter(id: string): SyncAdapter | undefined {
  return adapters.get(id);
}
